import React from 'react';

import { connect, useSelector } from 'react-redux'

import pageWithSideMenu from '../../containers/pageWithSideMenu'
import pageContent from '../../containers/pageContent'

import CPCDashboard from '../CPC/CPCDashboard';
import ContentNotFound from '../../containers/ContentNotFound';

const CPCSection = (props) => {
    const isSysadmin = useSelector((state) => state.user.name)
    const usesCPC = useSelector((state) => state.user.company.uses_cpc ?? false)

    if(usesCPC || isSysadmin) return <CPCDashboard />

console.log("isadmin=", isSysadmin)
console.log("usesCPC=", usesCPC)

    return (
        <ContentNotFound contentType="Data" />
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(CPCSection), "CPC Dashboard"));
